//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { phoneFilter } from '@/shared/utils/filters';

  export default {
    name: 'FCInput',
    props: {
      title: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
      error: Boolean,
      loading: Boolean,
      name: {
        type: String,
        default: '',
      },
      autocomplete: {
        type: String,
        default: '',
      },
      focus: Boolean,
      required: {
        type: Boolean,
        default: true,
      },
      autofocus: Boolean,
    },
    filters: {
      phone: phoneFilter,
    },
    mounted() {
      setTimeout(() => {
        if (this.focus) {
          this.$refs.inputobj.focus();
        }
      }, 150);
    },
    computed: {
      valuefilter() {
        if (this.type === 'tel') { return this.$options.filters.phone(this.value); }
        return this.value;
      },
    },
    methods: {
      updateInput() {
        this.$emit('input', this.$refs.inputobj.value);
      },
    },

  };
